import { createContext } from 'react';
import {
    Cell as ICell,
    Header as IHeader,
    Row as IRow,
    Table as ITable,
} from '@tanstack/table-core';

type TableVariant = 'bordered' | 'none';
interface ITableContext<T> {
    isLoading?: boolean;
    table: ITable<T>;
    searchTerm?: string;
    isFiltered?: boolean;
    isPersisted?: boolean;
    variant?: TableVariant;
    isActionHidden: boolean;
    setIsActionHidden: (isHidden: boolean) => void;
}

interface ITableRowContext<T> {
    row: IRow<T>;
}

interface ITableCellContext<T, K> {
    cell: ICell<T, K>;
}

interface ITableHeaderContext<T, K> {
    header: IHeader<T, K>;
}

interface ITableEmptyContext {
    variant?: 'primary' | 'secondary';
}

const TableContext = createContext<ITableContext<any>>({
    table: {} as ITable<any>,
    isActionHidden: false,
    setIsActionHidden: () => {},
    isPersisted: true,
});
const TableRowContext = createContext<ITableRowContext<any>>({
    row: {} as IRow<any>,
});

const TableCellContext = createContext<ITableCellContext<any, any>>({
    cell: {} as ICell<any, any>,
});

const TableHeaderContext = createContext<ITableHeaderContext<any, any>>({
    header: {} as IHeader<any, any>,
});

const TableEmptyContext = createContext<ITableEmptyContext>({
    variant: 'primary',
});

export { TableContext, TableRowContext, TableCellContext, TableHeaderContext, TableEmptyContext };
export type {
    TableVariant,
    ITable,
    ITableContext,
    ITableCellContext,
    ITableHeaderContext,
    ITableRowContext,
    ITableEmptyContext,
};
